import { axiosJsonInstance as axios } from "@/axios.instance";
import { Message } from "@/store/guard-chat/types";

const MESSAGES_URL = "/Messages";

interface CreateMessageCommand {
	message: string;
	messageType: string;
	eventId: number;
	mentionedUsers: number[];
}

const buildUrl = (eventId: number, afterId?: number) => {
	if (afterId) {
		return `${MESSAGES_URL}?eventId=${eventId}&afterId=${afterId}`;
	} else {
		return `${MESSAGES_URL}?eventId=${eventId}`;
	}
};

export const loadMessages = async (eventId: number, afterId?: number): Promise<Message[]> => {
	const url = buildUrl(eventId, afterId);
	const { data } = await axios.get(url);
	return data;
};

export const sendMessage = async (cmd: CreateMessageCommand): Promise<number> => {
	const { data } = await axios.post(MESSAGES_URL, cmd);
	return data;
};
